<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";



export default {


  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,

  },
  data() {

    return {
      title: "Ocorrências Finalizadoras",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Ocorrências Finalizadoras",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      showModalOcorFinal: false,
      submittedOcorFinal: false,
      ocorFinalData: {},
      dtListPesqUsuario: null,
      errosValid: null,

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {


    pesqUsuario(evt){
      console.log('pesqUsuario')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/userpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqUsuario = res.data
        });
      }
    },


    novaOcorrencia(){
      console.log('novaOcorrencia')
      this.ocorFinalData = {}
      this.submittedOcorFinal = false
      this.showModalOcorFinal = true


    },


    confOcorrencia(){
      console.log('confOcorrencia')
      this.submittedOcorFinal = true

      if (this.ocorFinalData.descricao && this.ocorFinalData.apirastreio) {
        this.showModalOcorFinal = false
        api.post(`${getBaseUrl()}api/ocorfinal`, {
          ocorFinalData: this.ocorFinalData
        }).then((res) => {
          console.log('res post ocorfinal')
          console.log(res)

          this.atualizaDataList()

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          })
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
        })
      }

    },


    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Ocorrências Finalizadoras'
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)


      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/ocorsfinal`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
      this.ocorFinalData = row.data

      this.dtListPesqUsuario = [
        {
          'id': this.ocorFinalData.user_id,
          'name': this.ocorFinalData.usuario
        }
      ]

      this.showModalOcorFinal = true
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeCanal(e) {
      switch (e.value) {
        case 'PU':
          return 'Pusher'

      }
      return 'Não Definido'
    },



    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Nova Ocorrência"
              :on-click="novaOcorrencia"/>

        </DxItem>

        <!--        <DxItem-->
        <!--            location="before"-->
        <!--            widget="dxButton">-->
        <!--          <DxButton-->
        <!--              icon="plus"-->
        <!--              hint="Importar arquivo de movimento"-->
        <!--              text="Novo Movimento"-->
        <!--              :on-click="novoMov"/>-->
        <!--        </DxItem>-->




      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strOcorFinalsList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />



        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="descricao"
            caption="Descrição"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="apirastreio"
            caption="API Tracking"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="left"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="statusdef"
            caption="Def.Status"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="usuario"
            caption="Usuário"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="created_at"
            caption="Criado"
            alignment="right"
            data-type="datetime"

            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>





        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal size="xl"
             :title="ocorFinalData.id > 0 ? `Editar Ocorrência Finalizadora (${ ocorFinalData.id })` : 'Criando nova Ocorrência Finalizadora'"
             v-model="showModalOcorFinal" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row">


            <div class="col-md-6">
              <label for="descricao">Descrição da ocorrência</label>
              <div class="position-relative">
                <input
                    id="descricao"
                    type="text"
                    v-model="ocorFinalData.descricao"
                    class="form-control"
                    placeholder="Descrição da ocorrência"
                    :class="{'is-invalid': submittedOcorFinal && !ocorFinalData.descricao}"/>
                <div v-if="submittedOcorFinal && !ocorFinalData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>



            <div class="col-sm-3">
              <div class="mb-3">
                <label for="apirastreio">API Tracking</label>
                <select
                    id="apirastreio"
                    v-model="ocorFinalData.apirastreio"
                    class="form-control"
                    :class="{'is-invalid': submittedOcorFinal && !ocorFinalData.apirastreio}">
                  <option value="ACX">Acerta Express</option>
                  <option value="AMAZON">Amazon</option>
                  <option value="ANYMARKET">Any Market</option>
                  <option value="B2WNOVA">B2W Nova Api</option>
                  <option value="BLING">Bling</option>
                  <option value="BRP">Braspres</option>
                  <option value="CORREIOS">Correios</option>
                  <option value="ESLC">ESL Cloud</option>
                  <option value="FOCUSNFE">Focus NFe</option>
                  <option value="FRILOG">Frilog</option>
                  <option value="JDL">JadLog</option>
                  <option value="LEROYMER">Leroy Merlin</option>
                  <option value="LJTO">LogJato</option>
                  <option value="LOJAMEC">Loja do Mecânico</option>
                  <option value="MAGALU">Magazine Luiza</option>
                  <option value="OCO">OCOREN</option>
                  <option value="QLTY">Quality</option>
                  <option value="PATR">Patrus</option>
                  <option value="RDV">Rodonavis</option>
                  <option value="RELM">Realmed</option>
                  <option value="SKYHUB">SkyHub</option>
                  <option value="SOL">Solistica</option>
                  <option value="SSW">SSW</option>
                  <option value="TRAYCORP">TrayCorp</option>
                  <option value="TNT">TNT</option>
                  <option value="TRCO">Transcourier</option>
                  <option value="TRV">Translovato</option>
                  <option value="VTEX">Vtex</option>

                </select>
                <div v-if="submittedOcorFinal && !ocorFinalData.apirastreio" class="invalid-feedback">
                  <span>Campo API Tracking obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>



            <div class="col-sm-3">
              <div class="mb-3">
                <label for="statusdef">Definir Status</label>
                <select
                    id="statusdef"
                    v-model="ocorFinalData.statusdef"
                    class="form-control">
                  <option value="ENP">Entregue no Prazo (ENP)</option>
                  <option value="ECR">Entregue com Ressalva (ECR)</option>
                  <option value="EAT">Entregue com Atraso (EAT)</option>
                  <option value="CPE">Comprovante de Entrega (CPE)</option>

                </select>

              </div>
            </div>




          </div>




        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalOcorFinal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confOcorrencia">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



  </Layout>
</template>
